// Centralised backend URL resolver.
//
// Why this exists: `frontend/.env` is not tracked in git (see .gitignore),
// so `REACT_APP_BACKEND_URL` cannot be reliably propagated to Netlify builds.
// The safer approach is to hardcode the production backend URL and gate it
// on the runtime hostname. This guarantees that customers on the live domain
// always hit the stable Emergent production backend, no matter what
// REACT_APP_BACKEND_URL is set to at build time.
//
// - roofing-goral.com  →  production backend (never sleeps)
// - anywhere else      →  REACT_APP_BACKEND_URL (dev/preview override)

const PROD_HOSTS = new Set(["roofing-goral.com", "www.roofing-goral.com"]);
const PROD_BACKEND = "https://roofing-us.emergent.host";

export function getBackendUrl() {
  if (typeof window !== "undefined" && PROD_HOSTS.has(window.location.hostname)) {
    return PROD_BACKEND;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

// Convenience for callers that want the /api-prefixed base.
export function getApiBase() {
  return `${getBackendUrl()}/api`;
}
